module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAp0lEQVRoge3asQ3CMAAF0R9ESYlYgAWYh8HYIEO5YwUWCDRukNyEGNBZ9+rox6e4zFRKeWZgu38f4NsMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkC64QP3K569J1k6vPOY5FD3ejjVvaY1gZckj83HSW5JrknOHbaSZK57TV7Rhk//bZt+tPdm+C9oIJ2BdAbSGUhnIN0LWpAMM1ssOTcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/telepresence.png
// module id = o1b8
// module chunks = 0